import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getListAuthorizationDocsFailed,
  getListAuthorizationDocsStart,
  getListAuthorizationDocsSuccess,
} from "../redux/getListAuthorizationDocs";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { getListAuthorizationDocsApi } from "core/http/service/authorizationDocument";
import { SCREEN } from "helper/roleChecker/Screens";
import { formSearchADSelectorDataSelector } from "../redux/selector";
import { mapValues, omit } from "lodash";
import { transformDate } from "helper/utils";

function* getListAuthorizationDocsWork(
  action: ReturnType<typeof getListAuthorizationDocsStart>
) {
  const id = action.payload.type;
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(id));
  const form = yield select(formSearchADSelectorDataSelector);
  const searchValue = mapValues(omit(form, ["isSearching"]), transformDate);

  const params = {
    offset,
    limit,
    ...searchValue,
    ...action.payload.params,
  };
  try {
    const res = yield call(getListAuthorizationDocsApi, {
      params,
      screenCode: SCREEN.IP_014,
    });

    yield put({
      type: getListAuthorizationDocsSuccess.type,
      payload: {
        type: id,
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListAuthorizationDocsFailed.type,
      payload: {
        type: id,
      },
    });
  }
}

function* watchGetListAuthorizationDocs() {
  yield takeEvery(
    getListAuthorizationDocsStart.type,
    getListAuthorizationDocsWork
  );
}

export default function* getListAuthorizationDocumentSaga() {
  yield all([watchGetListAuthorizationDocs()]);
}
